import { useEffect, useState } from "react";
import arrowLeft from "../assets/img/arrow-left.svg";
import { haveValue } from "../helper/common";
import { Button, Icon } from "./design";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

const getCleanFileName = (fileUrl) => {
  if (!fileUrl) return "";

  try {
    // Extract filename from URL
    const pathname = new URL(fileUrl).pathname;
    const fileName = pathname.split("/").pop();

    const parts = fileName.split(".");
    if (parts.length < 2) return fileName;

    const ext = parts.pop();
    const nameWithoutExt = parts.join(".");

    const segments = nameWithoutExt.split("_");

    if (segments.length > 1) {
      segments.pop(); // Remove last part after underscore
    }

    const cleanName = segments.join("");

    return `${cleanName}.${ext}`;
  } catch {
    // Fallback for plain filenames (not URLs)
    const parts = fileUrl.split(".");
    if (parts.length < 2) return fileUrl;

    const ext = parts.pop();
    const nameWithoutExt = parts.join(".");

    const segments = nameWithoutExt.split("_");
    if (segments.length > 1) {
      segments.pop();
    }

    return `${segments.join("")}.${ext}`;
  }
};

const FilePreviewModal = ({
  show,
  onClose,
  files = [],
  showIndex,
  hideDownload = false,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentFile, setcurrentFile] = useState(files[currentIndex]?.url);

  useEffect(() => {
    if (haveValue(showIndex)) {
      setCurrentIndex(showIndex);
    }
  }, [showIndex]);

  useEffect(() => {
    setcurrentFile(files[currentIndex]?.url);
  }, [currentIndex, files]);

  const handlePrev = () => {
    if (currentIndex > 0) setCurrentIndex(currentIndex - 1);
  };

  const handleNext = () => {
    if (currentIndex < files.length - 1) setCurrentIndex(currentIndex + 1);
  };

  const fileUrl = (currentFile ?? "").endsWith(".csv")
    ? "/images/csv-dummy.svg"
    : `${currentFile}`;

  const filePath = (currentFile ?? "").split("?")[0];

  const isImage = /\.(jpe?g|png|gif|webp|bmp|svg)$/i.test(filePath);

  // In Guarantor view-only mode the native PDF toolbar (download/print)
  // must be hidden. Chrome/Edge honor #toolbar=0 in the PDF viewer.
  const previewUrl =
    hideDownload && currentFile && !isImage && fileUrl && !fileUrl.includes("#")
      ? `${fileUrl}#toolbar=0&navpanes=0`
      : fileUrl;

  return (
    show && (
      <div
        className={`modal wrapper-modal file-viewer-modal fade ${
          show ? "show d-block" : ""
        }`}
        tabIndex="-1"
        role="dialog"
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className="modal-dialog gallery-modal modal-xl modal-dialog-scrollable"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header d-flex justify-content-between align-items-center modalHeader">
              <h5 className="modal-title">
                Preview File {currentIndex + 1} of {files.length}
              </h5>
              <Button
                variant="ghost"
                size="sm"
                iconOnly
                iconStart={<Icon name="close" />}
                aria-label="Close"
                onClick={() => onClose()}
              />
            </div>

            <div
              className="modal-body text-center"
              onContextMenu={
                hideDownload ? (e) => e.preventDefault() : undefined
              }
            >
              {isImage ? (
                <Zoom>
                  <img
                    src={fileUrl}
                    alt="Image"
                    draggable={hideDownload ? false : undefined}
                    onContextMenu={
                      hideDownload ? (e) => e.preventDefault() : undefined
                    }
                    style={{
                      maxWidth: "100%",
                      height: "100%",
                      width: "100%",
                      objectFit: "contain",
                      maxHeight: "calc(80vh - 140px)",
                      objectFit: "contain",
                    }}
                  />
                </Zoom>
              ) : (
                <iframe
                  src={previewUrl}
                  width="100%"
                  height="100%"
                  className="preview-file-model"
                  style={{ border: "none" }}
                  title="File preview"
                />
              )}
            </div>

            <div className="modal-footer d-flex justify-content-between">
              <Button
                variant="ghost"
                iconOnly
                iconStart={<img src={arrowLeft} alt="" />}
                aria-label="Previous"
                onClick={handlePrev}
                disabled={currentIndex === 0}
              />
              {/* <p className="file-name">{currentFile}</p> */}
              <p className="file-name">{getCleanFileName(currentFile)}</p>
              <Button
                variant="ghost"
                iconOnly
                iconStart={
                  <img
                    src={arrowLeft}
                    alt=""
                    style={{ transform: "rotate(180deg)" }}
                  />
                }
                aria-label="Next"
                onClick={handleNext}
                disabled={currentIndex === files.length - 1}
              />
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default FilePreviewModal;
